import { Component } from "@angular/core";
import { ToasterService } from "./toaster.service";

@Component({
    selector: 'app-toaster-container',
    template: `
    <app-toaster
        *ngFor="let toaster of toasterService.toasters(); let i = index"
        [toaster]="toaster"
        [top]="getTopPosition(i)"
        (close)="hideToaster($event)">
    </app-toaster>
    `,
    styles: [``]
})
export class ToasterContainerComponent {
    constructor(public toasterService: ToasterService) {}

    getTopPosition(index: number): string {
        return `${50 + (index * 95)}px`;
    }

    hideToaster(id: number) {
        this.toasterService.hideToaster(id);
    }
}
